import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { analytics, events } from 'services/analytics';
import { useAuthStore } from 'services/hooks';
import { locations } from 'services/routes/locations';

const useDiscoveryBanner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { authStore } = useAuthStore();
  const { isLoggedIn } = authStore;

  const CTAButtonText = useMemo(() => {
    if (!isLoggedIn) {
      return t('discoveryPage:discoveryBanner:ctaNoAccount');
    }

    return t('discoveryPage:discoveryBanner:ctaGenerateMusic');
  }, [t, isLoggedIn]);

  const handleCTAButtonClick = useCallback(() => {
    analytics.track(events.discoveryBannerClicked());

    if (!isLoggedIn) {
      return navigate(locations.general.register.pathname(''));
    }

    return navigate(locations.general.aiMusicGenerator);
  }, [isLoggedIn, navigate]);

  return {
    CTAButtonText,
    handleCTAButtonClick,
  };
};

export default useDiscoveryBanner;
